import React from 'react';
import { Phone } from 'lucide-react';
import { PHONE_NUMBER, PHONE_TEL_HREF } from '../../constants/site';
import { flattenNavItems } from '../../constants/nav';

export const MobileMenu = ({ navItems, onClose }) => (
  <div className="xl:hidden bg-[#0B1F3F] border-t border-white/10 py-4 rounded-b-2xl" data-testid="mobile-menu">
    <div className="flex items-center justify-center space-x-2 bg-sand-50 rounded-xl px-4 py-2 mx-4 mb-4 shadow-lg">
      <svg className="w-6 h-6 text-red-600" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" /></svg>
      <div className="flex flex-col">
        <span className="text-[#143160] text-sm font-black">VETERANS UNITED</span>
        <span className="text-[#c41e3a] text-xs font-bold">Preferred Agent</span>
      </div>
    </div>
    <div className="space-y-1">
      {flattenNavItems(navItems).map((item) => {
        const IconComponent = item.icon;
        const baseCls = `w-full flex items-center space-x-3 py-3 text-white hover:bg-white/10 transition-colors ${item.nested ? 'pl-12 pr-4 text-sm text-white/85' : 'px-4'}`;
        return item.type === 'scroll' ? (
          <button
            key={item.label}
            onClick={() => { item.action(); onClose(); }}
            className={`${baseCls} text-left`}
          >
            <IconComponent className="w-5 h-5 text-gold-400" />
            <span className="font-medium">{item.label}</span>
          </button>
        ) : (
          <a
            key={item.label}
            href={item.href}
            target={item.internal ? undefined : "_blank"}
            rel={item.internal ? undefined : "noopener noreferrer"}
            onClick={onClose}
            className={baseCls}
          >
            {item.nested ? <span className="w-1.5 h-1.5 rounded-full bg-gold-400" /> : <IconComponent className="w-5 h-5 text-gold-400" />}
            <span className="font-medium">{item.label}</span>
          </a>
        );
      })}
    </div>
    <div className="mt-4 px-4">
      <a href={PHONE_TEL_HREF} className="flex items-center justify-center space-x-2 bg-gold-400 text-[#143160] rounded-xl py-3 font-bold hover:bg-gold-300 transition-colors">
        <Phone className="w-5 h-5" />
        <span>Call Jess: {PHONE_NUMBER}</span>
      </a>
    </div>
  </div>
);
